import { Col } from 'antd';
import { UpdateQueryParams } from '@hooks';
import React, { useCallback } from 'react';
import {
	SearchFilter,
	SearchFilterContainer,
	SearchFilterQueryParams
} from '../filters';

export type FieldUpdateSearchQueryParams = { filters: string };

export interface FieldUpdateSearchProps {
	onChange: UpdateQueryParams<FieldUpdateSearchQueryParams>;
}

export const FieldUpdateSearch: React.FC<FieldUpdateSearchProps> = ({ onChange }) => {
	const handleChange = useCallback((params: SearchFilterQueryParams) => {
		onChange({ filters: params.query ? `DisplayName~like~"%${params.query}%"` : undefined });
	}, [ onChange ]);

	return (
		<SearchFilterContainer>
			<Col span={ 12 }>
				<SearchFilter onChange={ handleChange } />
			</Col>
		</SearchFilterContainer>
	);
};
